import { CourseLectureId } from '../types/course-lecture-interface'
import { CourseQuizId } from '../types/course-quiz-interface'
import { CourseStepEnum } from '../types/course-step-type'

type GetCoursePageUrlArgs = { coursePath: string } & (
  | {
      id: CourseLectureId
      type: CourseStepEnum.lecture
    }
  | {
      id: CourseQuizId
      type: CourseStepEnum.quiz
    }
  | {
      id: CourseLectureId
      type: CourseStepEnum.assignment
    }
  | {
      id?: never
      type?: never
    }
)

export const getCoursePageQuery = (args: GetCoursePageUrlArgs) => {
  return `/school/course/${args.coursePath}/${args.type}/${args.id}`
}
